(function(){
var R=document.getElementById('irz');if(!R)return;
var D=window.IRZ||{v:[],b:[],zp:0,bp:0,d:0,sel:null};
function $(id){return document.getElementById(id)}
function money(c){return '$'+(c/100).toFixed(2)}
var ZD={Aries:'Mar 21 – Apr 19',Taurus:'Apr 20 – May 20',Gemini:'May 21 – Jun 20',Cancer:'Jun 21 – Jul 22',Leo:'Jul 23 – Aug 22',Virgo:'Aug 23 – Sep 22',Libra:'Sep 23 – Oct 22',Scorpio:'Oct 23 – Nov 21',Sagittarius:'Nov 22 – Dec 21',Capricorn:'Dec 22 – Jan 19',Aquarius:'Jan 20 – Feb 18',Pisces:'Feb 19 – Mar 20'};
var STARTS=[[1,20,'Aquarius'],[2,19,'Pisces'],[3,21,'Aries'],[4,20,'Taurus'],[5,21,'Gemini'],[6,21,'Cancer'],[7,23,'Leo'],[8,23,'Virgo'],[9,23,'Libra'],[10,23,'Scorpio'],[11,22,'Sagittarius'],[12,22,'Capricorn']];
var form=$('irz-form'),btn=$('irz-btn'),msg=$('irz-msg'),signs=$('irz-signs'),chosen=$('irz-chosen'),addW=$('irz-add'),addck=$('irz-addck'),ini=$('irz-ini'),err=$('irz-err');
var track=$('irz-track'),slides=[].slice.call(track.querySelectorAll('.slide')),thumbs=[].slice.call(document.querySelectorAll('#irz-thumbs button')),dotsW=$('irz-dots');
var s0=slides[0],s0img=s0.querySelector('img'),stag=s0.querySelector('.stag'),t0img=thumbs[0]&&thumbs[0].querySelector('img');
var vmap={},byName={};D.v.forEach(function(v){vmap[v[0]]=v;byName[v[1]]=v});
var cur=null,canBuy=D.v.length>0;
var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

/* initials for the set */
D.b.filter(function(v){return v[1]==='Gold'&&v[3]}).map(function(v){return[v[2],v[0]]}).sort(function(a,b){return a[0]<b[0]?-1:1}).forEach(function(x){var o=document.createElement('option');o.value=x[1];o.textContent=x[0];ini.appendChild(o)});
if(ini.options.length<2){addW.style.display='none'}

/* gallery */
function vis(){return slides.filter(function(s){return!s.hidden})}
function idx(){var w=track.clientWidth||1;return Math.round(track.scrollLeft/w)}
function go(i,smooth){var vs=vis();if(!vs.length)return;i=(i+vs.length)%vs.length;track.scrollTo({left:vs[i].offsetLeft,behavior:smooth===false?'auto':'smooth'})}
function dots(){dotsW.innerHTML='';vis().forEach(function(){dotsW.appendChild(document.createElement('i'))});mark()}
function mark(){var i=idx(),vs=vis();slides.forEach(function(s,k){if(thumbs[k])thumbs[k].setAttribute('aria-current',vs[i]===s?'true':'false')});[].forEach.call(dotsW.children,function(d,k){d.className=k===i?'on':''})}
var tk=0;track.addEventListener('scroll',function(){if(tk)return;tk=requestAnimationFrame(function(){tk=0;mark()})},{passive:true});
R.querySelectorAll('.arr').forEach(function(a){a.addEventListener('click',function(){go(idx()+(+a.getAttribute('data-step')))})});
thumbs.forEach(function(t,k){t.addEventListener('click',function(){var i=vis().indexOf(slides[k]);if(i>-1)go(i)})});
dots();

/* sign selection */
function setSign(id,user){
 var v=vmap[id];if(!v)return;cur=v;
 var r=$('irz-v-'+id);if(r)r.checked=true;
 chosen.innerHTML='<strong>'+v[1]+'</strong> · '+(ZD[v[1]]||'');
 if(v[3]){s0img.src=v[3];s0img.srcset=v[4]+' 600w, '+v[3]+' 1100w';s0img.alt='Zodiac Constellation Necklace, '+v[1]+', on its sign card';if(t0img)t0img.src=v[5]}
 stag.textContent='Shown: '+v[1];stag.hidden=false;
 slides.forEach(function(s,k){if(s.hasAttribute('data-alt')){s.hidden=false;if(thumbs[k])thumbs[k].hidden=false}});
 dots();if(user)go(0,true);
 signs.classList.remove('err');msg.classList.remove('on');
 try{var u=new URL(location.href);u.searchParams.set('variant',id);history.replaceState(history.state,'',u.toString())}catch(e){}
 update();
}
signs.addEventListener('change',function(e){if(e.target.name==='id')setSign(+e.target.value,true)});

/* birthday finder */
var bd=$('irz-bday'),bdb=$('irz-bdbtn'),bm=$('irz-m'),bdd=$('irz-d'),bres=$('irz-bdres');
bdb.addEventListener('click',function(){var o=!bd.classList.contains('open');bd.classList.toggle('open',o);bdb.setAttribute('aria-expanded',o?'true':'false');if(o)bm.focus()});
function days(){var m=+bm.value,n=m?[31,29,31,30,31,30,31,31,30,31,30,31][m-1]:31,c=bdd.value;bdd.innerHTML='<option value="">Day</option>';for(var i=1;i<=n;i++){var o=document.createElement('option');o.value=i;o.textContent=i;bdd.appendChild(o)}if(c&&+c<=n)bdd.value=c}
function signOf(m,d){var s='Capricorn';STARTS.forEach(function(e){if(m>e[0]||(m===e[0]&&d>=e[1]))s=e[2]});return s}
function findSign(){var m=+bm.value,d=+bdd.value;if(!m||!d){bres.classList.remove('on');return}var n=signOf(m,d),v=byName[n];
 if(v&&v[2]){setSign(v[0],true);bres.innerHTML='She’s a <strong>'+n+'</strong> ('+ZD[n]+'). We’ve selected it for you.'}
 else{bres.innerHTML='She’s a <strong>'+n+'</strong>, which is sold out right now.'}
 bres.classList.add('on')}
bm.addEventListener('change',function(){days();findSign()});bdd.addEventListener('change',findSign);days();

/* price + button */
function total(){return addck.checked?D.zp+D.bp-D.d:D.zp}
var stS=$('irz-stsign'),stP=$('irz-stprice'),stB=$('irz-stbtn');
function update(){
 var on=addck.checked&&addW.style.display!=='none';addW.classList.toggle('on',on);
 var ready=!!cur&&(!on||!!ini.value);btn.setAttribute('data-ready',ready?'1':'0');
 btn.innerHTML=on?'Add the set – '+money(total())+' <s>'+money(D.zp+D.bp)+'</s>':'Add to bag – '+money(D.zp);
 stS.textContent=cur?(cur[1]+(on?' + her initial':' zodiac necklace')):'Zodiac Constellation Necklace';
 stP.textContent=money(total());stB.textContent=cur?(on?'Add the set':'Add to bag'):'Choose her sign';
}
addck.addEventListener('change',update);
ini.addEventListener('change',function(){ini.classList.remove('err');update()});

function need(el,block){el.scrollIntoView({behavior:'smooth',block:block||'center'})}
function add(){
 if(!canBuy){location.href=root+'collections/all';return}
 if(!cur){signs.classList.add('err');msg.classList.add('on');need(signs);return}
 var items=[{id:cur[0],quantity:1}];
 if(addck.checked&&addW.style.display!=='none'){if(!ini.value){ini.classList.add('err');need(ini);ini.focus({preventScroll:true});return}items.unshift({id:+ini.value,quantity:1})}
 if(btn.getAttribute('aria-busy')==='true')return;
 var old=btn.innerHTML;btn.setAttribute('aria-busy','true');btn.textContent='Adding…';err.classList.remove('on');
 fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
 .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
 .then(function(){location.href=root+'cart'})
 .catch(function(j){btn.removeAttribute('aria-busy');btn.innerHTML=old;err.textContent=(j&&j.description)||'Something went wrong. Please try again.';err.classList.add('on')});
}
form.addEventListener('submit',function(e){e.preventDefault();add()});
stB.addEventListener('click',function(){if(!cur){signs.classList.add('err');msg.classList.add('on');need(signs);return}add()});
$('irz-setgo').addEventListener('click',function(){addck.checked=true;update();if(!cur){need(signs,'start');signs.classList.add('err');msg.classList.add('on')}else{need(addW)}});

/* sticky bar */
var st=$('irz-stick');
if(st&&window.IntersectionObserver){new IntersectionObserver(function(es){var e=es[0];st.classList.toggle('on',!e.isIntersecting&&e.boundingClientRect.top<0)}).observe(btn)}

/* reveal */
if(window.IntersectionObserver){var io=new IntersectionObserver(function(es){es.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -8% 0px'});R.querySelectorAll('.rv').forEach(function(el){io.observe(el)})}else{R.querySelectorAll('.rv').forEach(function(el){el.classList.add('in')})}

/* initial state (variant in URL, or restored by the browser) */
var pre=signs.querySelector('input[name="id"]:checked');
if(pre)setSign(+pre.value,false);else if(D.sel&&vmap[D.sel])setSign(D.sel,false);else update();
})();
